export default {
  title: 'Sales Summary',
  description: 'Sales for the selected period — use for billing reconciliation with this restaurant.',
  filters: {
    period: 'Period',
  },
  presets: {
    this_month: 'This month',
    last_month: 'Last month',
    last_30_days: 'Last 30 days',
    this_year: 'This year',
  },
  fields: {
    orders_count: 'Orders',
    net_sales: 'Net Sales',
    sales_tax: 'Sales Tax',
    gross_sales: 'Gross Sales',
    delivery_fee_tax: 'Delivery fee (tax)',
    delivery_fee_gross: 'Delivery fee (gross)',
    tips_gross: 'Tips (gross)',
    total: 'Total',
  },
  kpi: {
    before_tax: 'before tax',
    tips: 'collected for the restaurant',
    owed_to_restaurant: 'owed to the restaurant',
  },
  table: {
    title: 'Breakdown',
    subtitle: '{{range}} · All amounts in {{currency}}',
    field: 'Field',
    amount: 'Amount',
    empty: 'No orders in the selected period',
    footnote:
      'Net Sales excludes tax; Gross Sales adds it back · Total is net of platform fees, so it is not what the customer paid · Refunds and chargebacks are netted off · Amounts in {{currency}}',
  },
  buttons: {
    export_csv: 'Export CSV',
    refresh: 'Refresh',
    retry: 'Try again',
  },
  errors: {
    failed_to_load: {
      title: 'Could not load the sales summary',
      description: 'Something went wrong while loading the report. Please try again.',
    },
  },
};
